import {
    ApolloClient,
    ApolloLink,
    HttpLink,
    InMemoryCache
} from '@apollo/client';
import { GraphQL17Alpha9Handler } from "@apollo/client/incremental";
import { SetContextLink } from "@apollo/client/link/context"

import { fingerprint } from "./common/auth";
import { API_URL, APP_NAME, AUTHENTIFICATION_MODE, LS_AUTH, REVISION } from "./config";

const authLink = new SetContextLink((_, { headers }) => {
    return {
        headers: {
            ...headers,
            Authorization: `Bearer ${fingerprint()}`,
            ...(AUTHENTIFICATION_MODE === 'TOKEN' && localStorage.getItem(LS_AUTH)
                ? {
                    'x-api-token': `${localStorage.getItem(LS_AUTH)}`,
                }
                : {}),
        },
    };
});

const httpLink = new HttpLink({
    uri: `${API_URL}graphql`,
    ...(AUTHENTIFICATION_MODE === 'COOKIE' ? { credentials: 'include' } : {}),
    //useGETForQueries :true
});

const client = new ApolloClient({
    name: APP_NAME,
    version: REVISION,
    link: ApolloLink.from([authLink, httpLink]),
    incrementalHandler: new GraphQL17Alpha9Handler(),
    defaultOptions: {
        watchQuery: {
            errorPolicy: 'all',
            fetchPolicy: 'cache-and-network',
        },
        query: {
            errorPolicy: 'all',
        },
        mutate: {
            errorPolicy: 'all',
        },
    },
    cache: new InMemoryCache({
        // Allow object merge for the following entities
        ...[
            'Brickfilm',
            'Message',
            'Resource',
            'OpeningVideo',
            'Article'
        ].reduce((acc, key) => ({ ...acc, [key]: { merge: true } }), {})
    }),
});

export default client;
